import { render, staticRenderFns } from "./CompetitionAdminUnapproved.vue?vue&type=template&id=3b825f19&scoped=true"
import script from "./CompetitionAdminUnapproved.vue?vue&type=script&lang=js"
export * from "./CompetitionAdminUnapproved.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAdminUnapproved.vue?vue&type=style&index=0&id=3b825f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b825f19",
  null
  
)

export default component.exports